import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Branch } from 'src/api/endpoints/branches/api';
import { RootState } from 'src/store/store';

const SELECTED_BRANCH_STORE_KEY = 'selected-branch-id';

const savedBranch =
    localStorage.getItem(SELECTED_BRANCH_STORE_KEY) !== null
        ? Number(localStorage.getItem(SELECTED_BRANCH_STORE_KEY))
        : null;

export type BranchSliceState = {
    branchId: number | null;
    branches: Branch[];
    isInitialized: boolean;
};

const initialState: BranchSliceState = {
    branchId: savedBranch || null,
    branches: [],
    isInitialized: false,
};

const branchSlice = createSlice({
    name: 'branch',
    initialState,
    reducers: {
        setActiveBranch: (
            state,
            action: PayloadAction<{ branchId: number }>
        ) => {
            state.branchId = action.payload.branchId;

            if (action.payload) {
                localStorage.setItem(
                    SELECTED_BRANCH_STORE_KEY,
                    action.payload.branchId + ''
                );
            }
        },
        setAvailableBranches: (state, action) => {
            state.branches = action.payload;

            if (!state.branchId && action.payload.length > 0) {
                state.branchId = action.payload[0].id;
            }
        },

        setInitialized: (state) => {
            state.isInitialized = true;
        }
    },
});

export const { setActiveBranch, setAvailableBranches, setInitialized } = branchSlice.actions;

export const selectActiveBranchId = (state: RootState) =>
    state.branchReducer.branchId;

export const selectAvailableBranches = (state: RootState) =>
    state.branchReducer.branches;

export const branchesIsInitialized = (state: RootState) =>
    state.branchReducer.isInitialized;

export default branchSlice.reducer;
